// extracted by mini-css-extract-plugin
export default {"no-results":"no-result_no-results__P0V9b"};